import "./Sale.scss";

import { Box, Button, Typography, withWidth } from "@material-ui/core";
import { AssetTypes } from "common/backend/types/utils";
import { ContentWrapper } from "common/components";
import { SaleManager } from "common/components/sale";
import { SaleManageable } from "common/store/sale/types";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import { StoreState } from "../../common/store/types";

function Sale() {
  // Hooks
  const {
    id, assetType
  } = useParams<{
    id: string;
    assetType: AssetTypes;
  }>();

  const sale = useSelector<StoreState, SaleManageable | undefined>((state: StoreState) => {
    const assetTypesSales = state.sales.get(assetType);
    return assetTypesSales && assetTypesSales.find((sale) => sale.id === id);
  });

  const history = useHistory();
  const { t } = useTranslation();

  const onPurchaseTokens = () => {
    history.push(`/shares/${sale?.id}`);
  };

  return (
    <>
      {sale &&
        <Box>
          <SaleManager values={sale} />

          <ContentWrapper
            minHeight="unset"
            justifyContent="center"
            padding="50px 11% 50px 11%"
          >
            <Box width="100%" maxWidth="764px">
              <Typography variant="body1" color="primary" className="ready-to-invest">
                {t("Ready to invest in this asset")}
              </Typography>

              <Button
                className="quinary"
                variant="contained"
                color="primary"
                fullWidth
                onClick={onPurchaseTokens}
              >
                {t("Purchase tokens")}
              </Button>
            </Box>
          </ContentWrapper>
        </Box>
      }
    </>
  );
}

export default withWidth()(Sale);
